const Vue = require('vue');
const body = document.body;

//let storyTemplates = require('../../templates/StoryTemplates');

//const templPath = '../../../../../../../templates/sidestories/default-story.pug';

const romanchukiStoryTemplate = require('../../../../../../../templates/sidestories/romanchuki-story.pug');
const korogodskyeStoryTemplate = require('../../../../../../../templates/sidestories/korogosdkye-story.pug');
const leboshkinyStoryTemplate = require('../../../../../../../templates/sidestories/leboshkiny-story.pug');

const storyTemplates = {
    romanchukiStory: romanchukiStoryTemplate,
    korogodskyeStory: korogodskyeStoryTemplate,
    leboshkinyStory: leboshkinyStoryTemplate
};

let curTemplate;
curTemplate;

Vue.component('side-story', {
    props: {
        content: String,
        redcolor: Boolean
    },
    data() {
        return {
            redBlockColor: false,
            currentTemplate: null,
            showSidestory: false
        };
    },
    created: function() {
        curTemplate = this.content;
        this.redBlockColor = this.redcolor ? true : false;
        this.currentTemplate = storyTemplates[curTemplate];
    },
    template: `
        <div class='side-menu' :class='{ show: showSidestory, red: redBlockColor }'>
            <div class='side-menu__background' @click='closeSidemenu()'>
            </div>
            <div class='side-menu__container'>
                <div class='close' @click='closeSidemenu()'></div>
                <div class='side-menu__wrapper' v-html='currentTemplate'>
                    {{currentTemplate}}
                </div>
            </div>
        </div>
    `,
    methods: {
        closeSidemenu() {
            this.showSidestory = false;
        }
    },
    watch: {
        showSidestory: function(showSidestoryVar) {
            if (showSidestoryVar) {
                body.classList.add('overflow-hidden');
            } else {
                body.classList.remove('overflow-hidden');
            }
        }
    }
});
